import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledAlert
} from "reactstrap";

import DataTable from "../../../Shared/DataTable";
import { MdDone, MdClear, MdAdd, MdSearch } from "react-icons/md";
import { NavLink } from "react-router-dom";
import {
  UserUploadContents,
  UserSpecificContents
} from "../../../../_constants/RouteVariables";
import Moment from "moment";
import { GoClock } from "react-icons/go";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../../_constants/tutorialmessages/ManualMessages";

const Approved = () => {
  return (
    <span style={{ color: "green" }}>
      <MdDone /> Approved
    </span>
  );
};
const Declined = () => {
  return (
    <span style={{ color: "red" }}>
      <MdClear /> Redraft
    </span>
  );
};

const Pending = () => {
  return (
    <span style={{ color: "#808080" }}>
      <GoClock /> Pending
    </span>
  );
};

export class PublishedContentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "all",
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.instructorPendingTable.target,
          tooltipOffset: 1000,
          style: {
            main: { top: "10rem" }
          },
          content: (
            <div>
              <p>{tourMessages.instructorPendingTable.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "15px" }}
              >
                {tourMessages.instructorPendingTable.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" }
        },
        tourMessages.default
      ],

      showNextJoyRide: false
    };
  }

  changeValue = event => {
    this.setState({ status: event.target.value });

    this.props.filterData({
      status: event.target.value !== "all" ? event.target.value : ""
    });
  };

  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "Interest",
        accessor: "interestName"
      },
      {
        Header: "Title",
        accessor: "title"
      },
      {
        Header: "Date",
        id: "submittedOn",
        maxWidth: 180,
        accessor: d => {
          return Moment(d.submittedOn)
            .local()
            .format("DD-MM-YYYY ");
        },

        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Status",
        accessor: "status",

        id: "status",
        sortable: true,
        filterable: true,
        Cell: row => (
          <span>
            {row.value === "APPROVED" ? (
              <Approved />
            ) : row.value === "PENDING" ? (
              <Pending />
            ) : (
              <Declined />
            )}
          </span>
        ),

        Filter: () => (
          <select
            onChange={this.changeValue}
            style={{ width: "60%" }}
            value={this.state.status}
          >
            <option value="all">Show All</option>
            <option value="APPROVED">Approved</option>
            <option value="DECLINED">Redraft</option>
            <option value="PENDING">Pending</option>
          </select>
        )
      },
      {
        Header: "Likes Count",
        accessor: "likesCount",

        id: "likesCount",
        sortable: true,

        Cell: row => (
          <span>
            {row.value > 0
              ? Number(row.value).toLocaleString("en-US")
              : "No likes yet"}
          </span>
        )
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      selectRow,
      deleteInterest,
      showModal,
      pages,
      page,
      pageSize,
      setPageNumber,
      filterData,
      setPageSize,
      showNextJoyRide
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "view",
        btnText: "View",
        isLink: true,
        to: UserSpecificContents,
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch
      }
    ];
    return (
      <div>
        {showNextJoyRide ? (
          <Joyride
            steps={steps}
            scrollToFirstStep
            showProgress
            showSkipButton
            styles={{
              options: {
                width: 200,
                height: 60,
                zIndex: 1000
              }
            }}
            callback={this.handleJoyrideCallback}
            run={run}
            stepIndex={stepIndex}
          />
        ) : null}

        <Card>
          <CardHeader>Published Contents</CardHeader>
          <CardBody className="joyride10">
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <NavLink to={UserUploadContents}>
              <Button color="primary mb-2" size="sm">
                <MdAdd /> Add
              </Button>
            </NavLink>
            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={5}
              deleteRow={deleteInterest}
              selectRow={selectRow}
              showModal={showModal}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              filterData={filterData}
              isView={true}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              searchPlaceholder="Search by title"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default PublishedContentTable;
